var map = {
	"./ec_binance futures.png": 45722,
	"./ec_binance usdm.png": 70525,
	"./ec_binance.png": 35282,
	"./ec_bitget.png": 9285,
	"./ec_bybit.png": 7944,
	"./ec_coinTR.png": 35479,
	"./ec_cointr [futures].png": 83041,
	"./ec_huobi jp.png": 84061,
	"./ec_huobi.png": 9875,
	"./ec_kraken.png": 65664,
	"./ec_mexc.png": 94743,
	"./ec_okx.png": 95494,
	"./ec_upbit.png": 89384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37283;